import { styled } from "@mui/material"

export const DropdownStyles = styled("button")(({ theme }) => ({
  display: "block",
  boxSizing: "border-box",
  position: "relative",
  left: 0,
  bottom: 0,
  minHeight: "56px",
  textAlign: "center",
  lineHeight: "56px",
  padding: 0,
  margin: 0,
  marginTop: "8px",
  marginBottom: "-8px",
  width: "100%",
  fontFamily: "inherit",
  fontSize: "inherit",
  border: "2px solid transparent",
  background: `${theme.palette.mockup.primary95}`,
  color: `${theme.palette.primary.main}`,
  textTransform: "uppercase",
  cursor: "pointer",
  borderBottomRightRadius: theme.shape.borderRadius,
  borderBottomLeftRadius: theme.shape.borderRadius,
  boxShadow: "0px 0px 0px rgba(210, 218, 249, 0.25)",
  ":hover": {
    transition: ".2s",
    background: theme.palette.primary.light,
  },
}))
